import $api from '@/http';
import type { SystemLinkLookup } from '@/utils/resolveSystemLink';
import { loadDocumentLinkTitles, textValue } from './loadDocumentLinkTitles';

/** Только API текущей системы: исходный URL никогда не используется как адрес запроса. */
export const loadSystemLinkTitle = async (
    lookup: SystemLinkLookup,
    signal: AbortSignal,
): Promise<string | undefined> => {
    const config = { signal, suppressErrorNotification: true, timeout: 10000 };
    const part = encodeURIComponent;
    switch (lookup.kind) {
        case 'document':
            return (await loadDocumentLinkTitles([lookup.id], signal))[lookup.id];
        case 'dictionary': {
            const { data } = await $api.get<{ canView: boolean; dictionaryName: string }>(
                `/dictionaries/scheme/${part(lookup.name)}`,
                config,
            );
            return data.canView ? textValue(data.dictionaryName) : undefined;
        }
        case 'report': {
            const { data } = await $api.get<{ title: string }>(
                `/folders/reports/info/${part(lookup.name)}/submenu/${part(lookup.folder)}`,
                config,
            );
            return textValue(data.title);
        }
        case 'dashboard': {
            const { data } = await $api.get<{ title?: string; Title?: string }>(
                `/dashboards/${lookup.path.map(part).join('/')}`,
                config,
            );
            return textValue(data.title ?? data.Title);
        }
        case 'notification': {
            const { data } = await $api.get<{ subject: string }>(`/notifications/${part(lookup.id)}`, config);
            return textValue(data.subject);
        }
    }
};
